// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.salarySpecificationScreen {
  width: 80%;
  margin: auto;
}
.salarySpecificationScreen .header {
  font-family: "Noto Sans KR";
  font-style: normal;
  font-weight: 700;
  font-size: 28px;
  line-height: 41px;
  color: #353d47;
  position: relative;
  left: 42px;
  top: 70px;
}
.salarySpecificationScreen .cardContainer {
  position: absolute;
  width: 80%;
  margin: auto;
  text-align: center;
  height: 387px;
  top: 273px;
}
.salarySpecificationScreen .salarySpecCard {
  width: 184px;
  display: inline-block;
  margin-left: 20px;
  margin-right: 20px;
  height: 242px;
  border: 1px solid rgba(0, 0, 0, 0.75);
  border-radius: 15px;
  box-shadow: 10px 10px 10px -10px rgba(0, 0, 0, 0.75);
}
.salarySpecificationScreen .imageContainer {
  width: 160px;
  height: 160px;
  position: relative;
  display: block;
  top: 10px;
  margin: auto;
}
.salarySpecificationScreen .title {
  position: relative;
  top: 10px;
}

.salary-specs {
  display: flex;
  height: 100%;
  flex-direction: column;
}
.salary-specs__head {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 700;
  font-size: 28px;
  line-height: 38px;
  color: #333333;
}
.salary-specs__cards {
  flex: 1 1;
  display: flex;
  align-items: center;
  justify-content: center;
}
.salary-specs__cards__list-of-employees {
  cursor: pointer;
}
.salary-specs__cards__transfer-of-mgt {
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/screens/salary_specification/salarySpecification.scss"],"names":[],"mappings":"AAAA;EACI,UAAA;EACA,YAAA;AACJ;AAAI;EACI,2BAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;EACA,UAAA;EACA,SAAA;AAER;AACI;EACI,kBAAA;EACA,UAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,UAAA;AACR;AAEI;EACI,YAAA;EACA,qBAAA;EACA,iBAAA;EACA,kBAAA;EACA,aAAA;EACA,qCAAA;EACA,mBAAA;EAGA,oDAAA;AAAR;AAEI;EACI,YAAA;EACA,aAAA;EACA,kBAAA;EACA,cAAA;EACA,SAAA;EACA,YAAA;AAAR;AAEI;EACI,kBAAA;EACA,SAAA;AAAR;;AAIA;EACI,aAAA;EACA,YAAA;EACA,sBAAA;AADJ;AAGI;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AADR;AAII;EACI,SAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAFR;AAIQ;EACI,eAAA;AAFZ;AAKQ;EACI,eAAA;AAHZ","sourcesContent":[".salarySpecificationScreen {\n    width: 80%;\n    margin: auto;\n    .header {\n        font-family: 'Noto Sans KR';\n        font-style: normal;\n        font-weight: 700;\n        font-size: 28px;\n        line-height: 41px;\n        color: #353d47;\n        position: relative;\n        left: 42px;\n        top: 70px;\n    }\n\n    .cardContainer {\n        position: absolute;\n        width: 80%;\n        margin: auto;\n        text-align: center;\n        height: 387px;\n        top: 273px;\n    }\n\n    .salarySpecCard {\n        width: 184px;\n        display: inline-block;\n        margin-left: 20px;\n        margin-right: 20px;\n        height: 242px;\n        border: 1px solid rgba(0, 0, 0, 0.75);\n        border-radius: 15px;\n        -webkit-box-shadow: 10px 10px 10px -10px rgba(0, 0, 0, 0.75);\n        -moz-box-shadow: 10px 10px 10px -10px rgba(0, 0, 0, 0.75);\n        box-shadow: 10px 10px 10px -10px rgba(0, 0, 0, 0.75);\n    }\n    .imageContainer {\n        width: 160px;\n        height: 160px;\n        position: relative;\n        display: block;\n        top: 10px;\n        margin: auto;\n    }\n    .title {\n        position: relative;\n        top: 10px;\n    }\n}\n\n.salary-specs {\n    display: flex;\n    height: 100%;\n    flex-direction: column;\n\n    &__head {\n        font-family: 'Spoqa Han Sans Neo';\n        font-style: normal;\n        font-weight: 700;\n        font-size: 28px;\n        line-height: 38px;\n        color: #333333;\n    }\n\n    &__cards {\n        flex: 1;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n\n        &__list-of-employees {\n            cursor: pointer;\n        }\n\n        &__transfer-of-mgt {\n            cursor: pointer;\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
